export default "__VITE_ASSET__Djyll3Ni__"